module.exports = __webpack_public_path__ + "static/media/main.c795132f.png";